import React, {FC, useState} from 'react';

import PopupFullPage from '../../../components/Popup/PopupFullPage';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import ModalTypes from '../../../enums/app/modalTypes';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import useHideModalIfNoDevice from '../../../hooks/useHideModalIfNoDevice';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {hideModalAction, showFWULedCheckAction} from '../../../state/ducks/modal';
import {dispatch} from '../../../state/store';
import FWUAdditionalStepsGuide from './components/FWUAdditionalStepsGuide/FWUAdditionalStepsGuide';
import FWUFirstStep from './components/FWUFirstStep/FWUFirstStep';

const FWUAdditionalStepsGuidePopup: FC<{modalType: ModalTypes}> = (props) => {
    const {modalType} = props;
    const [isFWUAdditionalStepsGuideVisible, setIsFWUAdditionalStepsGuideVisible] = useState<boolean>(false);
    const localizedStrings = getLocalizedStrings();

    const onClose = () => {
        if (!isFWUAdditionalStepsGuideVisible) {
            dispatch(showFWULedCheckAction());
        }
        dispatch(hideModalAction(modalType));
    };

    useDocumentTitle(localizedStrings[localizationKeys.ACCESSIBILITY_FEW_MORE_STEPS_PAGE_TITLE]);

    useHideModalIfNoDevice(modalType);

    return (
        <PopupFullPage containerClassName='flex flex-col'>
            {isFWUAdditionalStepsGuideVisible ? (
                <FWUAdditionalStepsGuide
                    onBackButtonClick={() => setIsFWUAdditionalStepsGuideVisible(false)}
                    onClose={onClose}
                />
            ) : (
                <FWUFirstStep onClose={onClose} onNextClick={() => setIsFWUAdditionalStepsGuideVisible(true)} />
            )}
        </PopupFullPage>
    );
};

export default FWUAdditionalStepsGuidePopup;
